// src/encounter/patient-reported-reader.tsx
// Mounted by the encounter page ONLY with `?x=patient-reported` on: runs the QuestionBank reads and hands the state up.
// A component rather than a hook in the page, so the page makes no query (and needs no QueryClient) with the switch off.
import { useEffect } from 'react';
import { usePatientReported, type PatientReportedState } from './services/use-patient-reported';

export interface PatientReportedReaderProps {
  patientId: string | null | undefined;
  questionnaireIds: readonly string[];
  onState: (state: PatientReportedState) => void;
}

export function PatientReportedReader({ patientId, questionnaireIds, onState }: PatientReportedReaderProps) {
  const state = usePatientReported(patientId, questionnaireIds, true);
  useEffect(() => onState(state), [state, onState]);
  return null;
}
